import { createKsStore, type KsStoreHook } from '@siclop/kstone-vue'
import { Activity } from '../models/Activity'
import { ActivityForm } from '../forms/ActivityForm'
import { ActivityFilter } from '../filters/ActivityFilter'
import { ActivityService } from '../services/ActivityService'

export const useActivityStore: KsStoreHook<Activity, ActivityForm, ActivityFilter> = createKsStore({
  id: 'activities',
  modelClass: Activity,
  formClass: ActivityForm,
  filterClass: ActivityFilter,
  service: ActivityService,
  labelField: (item) => item.description || `Activity #${item.id}`,
  signalREventName: 'ActivityModel'
})
